import { observable, computed, action, autorun } from 'mobx'

// Could not think of the appropriate amount of time to wait to clear the error
// So this randomly makes it between 1 and 5 minutes why not

const timeToClear = Math.floor(Math.random() * 240000) + 60000

export class ErrorStore {
  @observable errors = []
  @observable startDebounce = Date.now()
  @observable previousError = Date.now()

  constructor() {
    this.initAutoruns()
  }

  @computed get isStale() {
    return this.previousError - this.startDebounce > timeToClear
  }

  @action initAutoruns = () => {
    this.autoErrorClear()
  }

  @action autoErrorClear = () => {
    this.autoErrorDisposer = autorun(
      'Clear errors',
      () => {
        if (this.isStale) {
          this.clearErrors()
          this.resetCounter()
        }
      },
      {
        delay: 300
      }
    )
  }

  @action addError = (error) => this.errors.push(error)

  @action clearErrors = () => this.errors.clear()

  @action resetCounter = () => (this.startDebounce = Date.now())

  @action updatePreviousError = () =>
    (this.previousError = Date.now())

  @action checkForError = (error) =>
    this.errors.find((oldError) => oldError === error)

  @action shouldShowError = (error) => {
    this.updatePreviousError()
    const isInErrors = this.checkForError(error)

    this.addError(error)
    return !isInErrors
  }
}

export default new ErrorStore()
